import React, { useState, useMemo } from "react"; // Added useMemo for efficiency
import CrewCard from "./CrewCard";
import { Switch } from "components/ui/switch";

const CrewMatchListings = ({ matchedCrew = [], selectedCrewIds = [], onCrewSelection, openCrewModal }) => {
  const [hideBeigeProfiles, setHideBeigeProfiles] = useState(false);

  // 1. Get organizationType from localStorage
  const userData = JSON.parse(localStorage.getItem("user") || "{}");
  const organizationType = userData?.organizationType;

  // Determine if we should show the toggle (hide it if type is 2)
  const showBeigeToggle = organizationType !== 2;

  // 2. Apply filtering based on hideBeigeProfiles state
  const filteredCrew = hideBeigeProfiles
    ? matchedCrew.filter(crew => crew.is_beige_member === 0)
    : matchedCrew;

  const handleCrewToggle = (crewMemberId) => {
    const isSelected = selectedCrewIds.includes(crewMemberId);
    if (onCrewSelection) {
      onCrewSelection(crewMemberId, !isSelected);
    }
  };

  return (
    <div className="border border-border bg-card rounded-2xl p-6">
      <div className="mb-6">
        <div className="flex justify-between items-center mb-2">
          <p className="text-2xl text-foreground font-semibold">
            Crew Matches ({filteredCrew.length})
          </p>

          {showBeigeToggle && (
            <div className="hidden md:flex text-sm text-muted-foreground items-center gap-2 ">
              <Switch
                id="hide-beige-profiles"
                checked={hideBeigeProfiles}
                onCheckedChange={setHideBeigeProfiles}
                className={`data-[state=checked]:bg-button-coloured data-[state=unchecked]:bg-muted data-[state=unchecked]:bg-accent relative inline-flex h-6 w-12 shrink-0 cursor-pointer rounded-full border-0 transition-colors duration-200`}
              />
              <p className="text-sm font-semibold text-foreground">Hide Beige profiles</p>
            </div>
          )}
        </div>

        <p className="text-muted-foreground text-sm font-normal leading-5">
          Based on your requirements, we've matched you with {filteredCrew.length} crew member{filteredCrew.length !== 1 ? 's' : ''} with availability on your event date and location proximity.
        </p>

        {showBeigeToggle && (
          <div className="flex md:hidden text-sm text-muted-foreground items-center gap-2 mt-4">
            <Switch
              id="hide-beige-profiles-mobile"
              checked={hideBeigeProfiles}
              onCheckedChange={setHideBeigeProfiles}
              className={`data-[state=checked]:bg-button-coloured data-[state=unchecked]:bg-muted data-[state=unchecked]:bg-accent relative inline-flex h-6 w-12 shrink-0 cursor-pointer rounded-full border-0 transition-colors duration-200`}
            />
            <p className="text-sm font-semibold text-foreground">Hide Beige profiles</p>
          </div>
        )}
      </div>

      {filteredCrew.length === 0 ? (
        <div className="text-center py-12 text-muted-foreground">
          <p className="text-lg font-semibold">No crew matches found</p>
          <p className="text-sm mt-2">Try adjusting your requirements or search criteria</p>
        </div>
      ) : (
        <div className="flex flex-col gap-6">
          {filteredCrew.map((crew) => (
            <CrewCard
              key={crew.crew_member_id}
              crewMember={crew}
              isSelected={selectedCrewIds.includes(crew.crew_member_id)}
              onSelect={() => handleCrewToggle(crew.crew_member_id)}
              onViewProfile={() => openCrewModal(crew)}
            />
          ))}
        </div>
      )}
    </div>
  )
}

export default CrewMatchListings;
